module.exports = __webpack_public_path__ + "static/media/contest2025_third_place_profileImage.f7bca2d1.jpeg";